import { useEffect } from 'react';

const useGoogleFont = (fontLink) => {
    useEffect(() => {
        const link = document.createElement('link');
        link.href = fontLink;
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [fontLink]);
};

export default useGoogleFont;
